import { Component, computed, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { DateService } from 'src/app/services/date/date.service';
import { ciInterface2 } from 'src/app/util/interfaces/ci';
import { logInterface } from 'src/app/util/interfaces/log.interface';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { CmdbRegisterPageLogsService } from './data/cmdb-register-page-logs.service';
import { DotBounceLoadingEffectModule } from 'src/app/page_component_item/dot-bounce-loading-effect/dot-bounce-loading-effect.module';
import { ShkDate } from 'shk-date';

@Component({
	selector: 'cpi-cmdb-register-page-logs',
	standalone: true,
	imports: [DotBounceLoadingEffectModule],
	templateUrl: './cmdb-register-page-logs.component.html',
	styleUrl: './cmdb-register-page-logs.component.scss',
})
export class CmdbRegisterPageLogsComponent implements OnInit {
	private readonly cmdbRegisterPageLogsService = inject(CmdbRegisterPageLogsService);
	private readonly labelsService = inject(LabelsService);
	public readonly dateService = inject(DateService);

	@Input() selectedCi: ciInterface2;

	labels: LabelsInterface;

	isLoadingLogs = true;

	ciLogReq: Subscription;
	ciLogs: logInterface[] = [];

	@Output() getLogDate = new EventEmitter<ShkDate>();

	constructor() {
		this.labels = computed(() => this.labelsService.labels())();
	}

	ngOnInit(): void {
		this.getCiLogs(this.selectedCi.id);
	}

	getCiLogs(idCi: string): void {
		if (this.ciLogReq) this.ciLogReq.unsubscribe();
		this.isLoadingLogs = true;
		this.ciLogReq = this.cmdbRegisterPageLogsService.getCiLogs(idCi).subscribe({
			next: (ciLogs) => {
				this.ciLogs = ciLogs;
			},
		});

		this.ciLogReq.add(() => {
			this.isLoadingLogs = false;
		});
	}

	viewBaseline(date: string): void {
		this.getLogDate.emit(new ShkDate(date));
	}
}
